import React from "react";

import StyleValuesBreakdownSlice from "../../components/slices/styleValuesBreakdown/StyleValuesBreakdownSlice";

const StyleValuesBreakdown = ({ slice }) => {
  return <StyleValuesBreakdownSlice slice={slice} />;
};

export default StyleValuesBreakdown;
